// extracted by mini-css-extract-plugin
module.exports = {"recordingConsentEmpty":"clinical-portal-3__RecordingConsent__recordingConsentEmpty"};